import React from 'react';
import {
  Keyboard,
} from 'react-native';

import { grtAtom, grtStt } from './_csRcl';

import * as hf from './_hf';
import * as ht from './_ht';

import { useCmnz } from './_csCmn';

const _getBdySftY = (pd: {
  nKbdMsrH: number,
  nKbdMsrY: number,
  nIptMsrH: number,
  nIptMsrY: number,
}) => {

  const _sCz = useCmnz();

  const _nOstH = 0; // offset H
  if (pd.nIptMsrY == undefined) return 0;
  let _dy = (pd.nIptMsrY + pd.nIptMsrH + _nOstH) - (pd.nKbdMsrY);
  if (_dy >= (pd.nKbdMsrH - _sCz.h('ftr'))) _dy = pd.nKbdMsrH - _sCz.h('ftr'); // キーボード分のみが対象
  if (_dy < 0) _dy = 0; // 下側が被った場合のみが対象
  return _dy;
};

const oKbdMsrz = grtAtom('kbd.kbdMsrz', {
  bShow: false,
  msrz: {}, // do not set initial value
  nBdySftY: 0,
});

const oIptMsrz = grtAtom('kbd.iptMsrz', {
  ox: 0,
  oy: 0,
  w: 0,
  h: 0,
  px: 0,
  py: 0,
});

export const useKbdMsrz = () => {
  return grtStt(oKbdMsrz)
};

export const useIptMsrz = () => {
  const _sz = grtStt(oIptMsrz);
  return {
    ..._sz,
    clrMsrz: () => { // set at input onBlur
      const _dz = {
        ox: 0,
        oy: 0,
        w: 0,
        h: 0,
        px: 0,
        py: 0,
      };
      //ff.l('Kbd 72: {}'.f(_dz));
      _sz.set(_dz);
    },
    setMsrz: (poRefView: ht.a) => { // set at input onFocus, onContentSizeChange
      poRefView.current.measure((_oX: ht.n, _oY: ht.n, _w: ht.n, _h: ht.n, _pX: ht.n, _pY: ht.n) => {
        const _dz = {
          ox: _oX,
          oy: _oY,
          w: _w,
          h: _h,
          px: _pX,
          py: _pY,
        };
        //ff.l('Kbd 85: {}'.f(_dz));
        _sz.set(_dz);
      });
    }
  }
};

const _KbdRoot = React.memo((pd: {
  children: React.ReactElement,
}): React.ReactElement => {

  const _sKbdMsrz = useKbdMsrz();
  const _sIptMsrz = useIptMsrz();

  React.useEffect(() => {
    const _lnrShow = Keyboard.addListener('keyboardDidShow', (_e) => { //_e.endCoodinates.height : keyboard height
      //ff.l('Kbd 103: here');
      if (hf.f(_sKbdMsrz.crt.msrz) == false) { // 表示のばたつき防止
        const _dz = {
          bShow: true,
          msrz: _e.endCoordinates
        };
        //ff.l('Kbd 106: {}'.f(_dz));
        _sKbdMsrz.set(_dz);
      }
    });

    const _lnrHide = Keyboard.addListener('keyboardDidHide', () => {
      const _dz = {
        bShow: true,
        msrz: {}
      };
      //ff.l('Kbd 116: {}'.f(_dz));
      _sKbdMsrz.set(_dz);
    });

    return () => {
      _lnrShow.remove();
      _lnrHide.remove();
    };
  }, [])

  React.useEffect(() => {
    //ff.l('Kbd 129: {}'.f(_sKbdMsrz.crt.bShow));
    if (_sKbdMsrz.crt.bShow) { // show
//      if (cf.myRN_chkOS('a') == false) {
        //ff.l('Kbd 129: here');
        _sKbdMsrz.set({
          nBdySftY: _getBdySftY({
            nKbdMsrH: _sKbdMsrz.crt.msrz.height,
            nKbdMsrY: _sKbdMsrz.crt.msrz.screenY,
            nIptMsrH: _sIptMsrz.crt.h,
            nIptMsrY: _sIptMsrz.crt.py,
          }),
        });
//      };
    }
    else { // hide
//      if (cf.myRN_chkOS('a') == false) {
        //ff.l('Kbd 140: here');
        _sKbdMsrz.set({
          nBdySftY: 0,
        });
//      };
    }
  }, [
    _sKbdMsrz.crt.bShow,
    _sKbdMsrz.crt.msrz.height,
    _sKbdMsrz.crt.msrz.screenY,
    _sIptMsrz.crt.h,
    _sIptMsrz.crt.py,
  ])

  //ff.l('Kbd 151: here');
  return (
    pd.children
  )
});
export default _KbdRoot;
